import { render, staticRenderFns } from "./MTStatusList.vue?vue&type=template&id=4b0982ba&scoped=true"
import script from "./MTStatusList.vue?vue&type=script&lang=js"
export * from "./MTStatusList.vue?vue&type=script&lang=js"
import style0 from "./MTStatusList.vue?vue&type=style&index=0&id=4b0982ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0982ba",
  null
  
)

export default component.exports